module.exports = __webpack_public_path__ + "img/campaign_mission.c0671b29.jpg";